import { createFileRoute } from '@tanstack/react-router';
import ReimbursementDetailTable from '@/modules/reimbursement-detail/ReimbursementDetailTable';

export const Route = createFileRoute('/(dashboard)/_dashboard/finance/reimbursement/$id/')({
  component: ReimbursementDetailTable,
});
